import { gql } from '@/__generated__';

/**
 * `success`/`code`/`message` son la fuente de verdad del resultado (AMARU-862/US-003): `movement`
 * solo viene en la aceptación y en `QUEUED` (la solicitud encolada), así que su ausencia no
 * distingue un no-op de un rechazo ni de un error de transporte. El frontend clasifica con
 * `classifyGateCommandOutcome`.
 */
export const REQUEST_GATE_MOVEMENT = gql(`#graphql
  mutation RequestGateMovement($input: RequestGateMovementInput!) {
    requestGateMovement(input: $input) {
      success
      code
      message
      queuedRequest {
        requestedPosition
        requestedAt
        expiresAt
      }
      movement {
        ...GateMovementFragment
      }
    }
  }
`);
